module.exports = __webpack_public_path__ + "img/card-front-image.11604e0b.png";